var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CollapseCard',{attrs:{"title":"Qualified R&D Activities","subtitle":((_vm.activities.length) + " Qualified Activities"),"ident":"activities"}},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('b-button',{staticClass:"action-btn ml-2",attrs:{"id":"btn-configure-activities","variant":"primary","size":"sm","to":{name: 'activities-configure', params: {id: _vm.$companyId}}}},[_vm._v(" Configure Qualified Activities ")])],1),_c('b-table',{class:[_vm.activities.length > 0 ? 'mb-0' : 'mb-5'],attrs:{"id":"table-activities","thead-class":"table-head","fields":[
         {key: 'name', sortable: true},
         {
            key: 'atype',
            label: 'Type',
            formatter: function (val) { return _vm.ActivityType[val]; },
            sortable: true,
            sortByFormatted: true,
         } ],"sort-by":"name","items":_vm.activities}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }